module.exports = __webpack_public_path__ + "6e760fc1f3f4598bc2b6aa9ca533b04b.gif";